import { MemberChangeLog } from 'src/modules/member/models/memberChangeLog';
import { setPagingParams } from '../functions/createPagingParams';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'MemberChangeLog';

export const getMemberChangeLog = (pageIndex, pageSize, sortCol, sortDir, associationId, districtId) => {
  let extraQuery = '';
  extraQuery += associationId ? `&associationId=${associationId}` : '';
  extraQuery += districtId ? `&districtId=${districtId}` : '';
  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<MemberChangeLog>>(endpoint);
};

export const getSpecificMemberChangeLog = (pageIndex, pageSize, sortCol, sortDir, memberId) => {
  const extraQuery = `&memberId=${memberId}`;
  const endpoint = `${controller}/?${setPagingParams({
    pageIndex,
    pageSize,
    sortCol,
    sortDir,
  })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<MemberChangeLog>>(endpoint);
};
